import { useQuery } from '@tanstack/react-query'
import { accessOf, canFinance, canOpening } from '@/lib/admin-access'
import { backofficeApi } from '@/lib/api-client'
import { DESK_REFETCH_MS, visibleTabRefetch } from '@/lib/query-client'
import { useAuthStore } from '@/store/auth'

/** Open-item counts. Both scopes return every count; the scope only picks the route the role may call. */
export function useDeskSummary(scope?: 'opening' | 'settlement') {
  const role = accessOf(useAuthStore((s) => s.user))
  const resolved = scope ?? (canFinance(role) ? 'settlement' : 'opening')
  const allowed = resolved === 'settlement' ? canFinance(role) : canOpening(role)
  return useQuery({
    queryKey: ['desk-summary', resolved],
    queryFn: () => backofficeApi.deskSummary(resolved),
    enabled: allowed,
    ...visibleTabRefetch(DESK_REFETCH_MS),
  })
}
